import React from "react";

//Components
import ProductIntro from "./ProductIntro";
import ProductInfo from "./ProductInfo";
import Features from "./Features";

function ProductsSection() {
  return (
    <div className="productsSection">
      <ProductIntro />
      <ProductInfo />
      <Features />
    </div>
  );
}

export default ProductsSection;
